import i18n from './reacti18n';
import { getEligibleFilters } from './page';

const docTypeOptions = {
  faq: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.faq'),
  mts: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.mtsFaq'),
  brc: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.brc'),
  developer: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.dev'),
  product: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.mpp'),
  community: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.community'),
};

/**
 * Return the Search Filter Form Field Objects as per given options.
 * @return {Array}               Array of Search Filter Form Field Objects.
 */
const getSearchFilter = () => {
  const fieldOptions = getEligibleFilters();
  const defaultOptions = ['faq'];

  const searchFilters = [{
    id: 'docType',
    type: 'radio',
    label: '',
    isRequired: false,
    hasError: false,
    value: 'faq',
    options: [],
  }];

  const eligibleOptions = (fieldOptions.length > 0) ? fieldOptions : defaultOptions;

  searchFilters[0].options = eligibleOptions.map(value => ({
    label: docTypeOptions[value],
    value,
  }));
  return searchFilters;
};

const mobileFilter = {
  apply: i18n.message('smarthelp/searchResult.searchResult.mobile.filter.apply'),
};

const searchMobileButton = {
  id: 'mobileButton',
  type: 'button',
  submitLabel: mobileFilter.apply,
  resetLabel: '',
  hasCancelButton: false,
  submitButtonStyle: 'submit-button-container submit-button-container__gird',
  handleCancel: () => {},
};

export default { docTypeOptions, getSearchFilter, searchMobileButton };
